var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg30(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "197.3mm",
    height: "122.46mm",
    viewBox: "0 0 197.3 122.46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18604"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18656"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18676"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18686"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18704"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m331.88 253.33 17.74-51.97-51.97-17.74-17.74 51.97z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18714"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18724"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m332.25 162h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18734"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18756"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m446.25 152.25h66.75v66.75h-66.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18766"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18776"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m530.1 368.35 54.37-47.2-47.2-54.37-54.37 47.2z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18786"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18796"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m530.25 150.75h58.5v59.25h-58.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18806"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18840"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m586.5 160.5h98.25v98.25h-98.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18850"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18906"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m296.08 197.12 22.07-18.14-18.65-22.7-22.08 18.15z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18916"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18970"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m389.41 328.65 20.46-69.03-69.04-20.46-20.45 69.04z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18980"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19012"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m156.75 61.5h122.25v121.5h-122.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19022"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19034"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.25 141h120.75v120.75h-120.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19044"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19060"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.5 192.75h66.75v66.75h-66.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19080"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m492.75 189.75h66v66.75h-66z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19090"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19104"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m300 171h29.25v28.5h-29.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288.41 213.36 28.48-7.21-7.01-27.7-28.48 7.2z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19134"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19144"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m392.25 153.75h66.75v66h-66.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath19154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-601.74 -430.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 548.07 573.68)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18604)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,485.4)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 24.045349 39.799198 49.568748 65.35865 74.371147 91.639099 109.6641 120.9117 132.19534 141.20786 150.22035 166.01025 180.25 192.25465 201.26715 218.5351 229.02565 244.81555 262.0835 272.57404 289.84201 300.36859 311.65225 320.66476 336.45465",
    y: 0
  }, "Catalog files in an office"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18616)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,372,485.4)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 12.00465 36.049999",
    y: 0
  }, "(C)"))), /*#__PURE__*/React.createElement("path", {
    d: "m397.88 297c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.88 297c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.38 223.87h16.5v45h-16.5z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.38 223.87h16.5v45h-16.5z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.88 222.37h16.5v44.25h-16.5z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.88 222.37h16.5v44.25h-16.5z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.38 307.12c0 9.12 7.55 16.5 16.87 16.5s16.88-7.38 16.88-16.5c0-9.11-7.56-16.5-16.88-16.5s-16.87 7.39-16.87 16.5z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.38 307.12c0 9.12 7.55 16.5 16.87 16.5s16.88-7.38 16.88-16.5c0-9.11-7.56-16.5-16.88-16.5s-16.87 7.39-16.87 16.5z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.88 307.12c0 9.12 7.72 16.5 17.25 16.5 9.52 0 17.25-7.38 17.25-16.5 0-9.11-7.73-16.5-17.25-16.5-9.53 0-17.25 7.39-17.25 16.5z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.88 307.12c0 9.12 7.72 16.5 17.25 16.5 9.52 0 17.25-7.38 17.25-16.5 0-9.11-7.73-16.5-17.25-16.5-9.53 0-17.25 7.39-17.25 16.5z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.88 304.95c0-1.08-0.88-1.95-1.95-1.95-1.08 0-1.95 0.87-1.95 1.95s0.87 1.95 1.95 1.95c1.07 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.81 305.15c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95 0 1.07 0.88 1.95 1.95 1.95 1.08 0 1.95-0.88 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.13 338.62 25.5 50.25 25.5-50.25z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m421.13 338.62 25.5 50.25 25.5-50.25z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.76 277.43-11.87-7.69c-6.56-4.24-13.97-4.45-16.55-0.47-2.58 3.99 0.64 10.66 7.2 14.91l11.87 7.69z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.76 277.43-11.87-7.69c-6.56-4.24-13.97-4.45-16.55-0.47-2.58 3.99 0.64 10.66 7.2 14.91l11.87 7.69z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m483.15 305.46 17.69 8.32c9.77 4.59 19.72 3.99 22.22-1.33 2.51-5.32-3.39-13.36-13.16-17.95l-17.69-8.32z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m483.15 305.46 17.69 8.32c9.77 4.59 19.72 3.99 22.22-1.33 2.51-5.32-3.39-13.36-13.16-17.95l-17.69-8.32z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m468.38 287.25c0-6.01-9.91-10.88-22.13-10.88s-22.12 4.87-22.12 10.88h5.43c0-3 7.47-5.44 16.69-5.44s16.69 2.44 16.69 5.44z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.38 287.25c0-6.01-9.91-10.88-22.13-10.88s-22.12 4.87-22.12 10.88h5.43c0-3 7.47-5.44 16.69-5.44s16.69 2.44 16.69 5.44z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.38 163.12 21.18 84.75h390.38l21.19-84.75z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.38 163.12 21.18 84.75h390.38l21.19-84.75z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18704)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.2464 .72186 -.72186 -.2464 349.62 201.36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.329 61.398c0.787 0.89 0.98 2.686-1.075 4.822-0.872 0.979-2.098 1.572-3.408 1.646-0.581 0.028-1.15-0.171-1.588-0.554l-22.715-21.201-2.283-2.271-14.584-15.141c-0.567-0.581-1.114-1.181-1.641-1.8l-6.482-7.314-2.025-2.553-5.3848-7.0413c-0.2102-0.3768-0.1308-0.849 0.1913-1.1362l-1.7063-2.775c-0.1983-0.3129-0.1494-0.7221 0.117-0.9795 0.147-0.1485 0.3469-0.2327 0.5558-0.234 0.1506 7e-4 0.298 0.0438 0.4252 0.1245l2.748 1.725c0.1922-0.1906 0.4495-0.301 0.72-0.309 0.1435-0.0023 0.2844 0.0393 0.4035 0.1192l7.0973 5.3373 2.566 2.012 7.314 6.483c0.619 0.526 1.219 1.073 1.8 1.64l15.142 14.585 2.273 2.281 17.969 18.802 0.191 0.2 0.592-0.592c0.586-0.585 0.586-1.535 0-2.121l-13.38-13.38c-0.297-0.288-0.304-0.763-0.015-1.06 0.288-0.297 0.763-0.304 1.06-0.015 6e-3 6e-3 0.013 0.012 0.018 0.018l13.381 13.38c1.171 1.171 1.171 3.07 0 4.242l-0.616 0.616 0.838 0.876zm-57.926-53.141-1.5285 1.5293 4.827 6.313 0.437 0.551 3.178-3.177-0.525-0.41zm17.924 14.816c-0.554-0.541-1.134-1.07-1.748-1.592l-7.28-6.45-0.795-0.624-3.428 3.428 0.625 0.787 6.475 7.307c0.503 0.591 1.032 1.171 1.575 1.732l14.566 15.116 0.537 0.533 5.133-5.133-0.512-0.514zm17.4 16.85-0.681-0.684-5.129 5.129 0.667 0.663 22.696 21.185 0.014 0.013 0.019 0.018c0.162 0.09 0.347 0.132 0.532 0.119 0.897-0.087 1.728-0.511 2.325-1.187 1.238-1.286 1.41-2.332 1.045-2.775l-1.475-1.543-2.066-2.161z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.25,162)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18734)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.384 39.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 45.366h14.25v1.5h-14.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 33.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 27.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 21.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 15.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.884 66.366v-60h45v43.81l-16.19 16.19zm29.263-2.573 13.164-13.164c3e-3 -3e-3 3e-3 -8e-3 0-0.011-2e-3 -1e-3 -4e-3 -2e-3 -6e-3 -2e-3h-13.171v13.171c0 5e-3 3e-3 8e-3 8e-3 8e-3 2e-3 0 3e-3 -1e-3 5e-3 -2e-3zm-27.763-55.927v57h26.25v-15.75h15.75v-41.25z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18756)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.92708 -1.88e-7 -3.77e-7 .92708 446.25 152.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.634 15.35h49.5c1.655 6e-3 2.995 1.346 3 3v30.009c-5e-3 1.655-1.345 2.995-3 3h-25.5l-8.25 5.475c-0.472 0.362-1.056 0.548-1.65 0.525h-14.1c-1.6548-5e-3 -2.9951-1.345-3-3v-36.008c0.0045-1.655 1.3449-2.996 3-3.001zm-1.5 39.011c0 0.828 0.672 1.5 1.5 1.5h14.1c0.243 0.017 0.485-0.045 0.689-0.177l0.063-0.053 0.068-0.045 8.25-5.475 0.375-0.25h25.955c0.828 0 1.5-0.672 1.5-1.5v-30.01c0-0.828-0.672-1.5-1.5-1.5h-49.5c-0.828 0-1.5 0.672-1.5 1.5z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18776)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.75512 -.65558 .65558 .75512 482.9 313.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5867 15.37c0.0264-9e-3 0.0535-0.015 0.081-0.02h46.466l10.2 21.906c0.728 1.52 0.086 3.343-1.434 4.071-0.304 0.146-0.631 0.24-0.966 0.279h-3.3v6.75c-5e-3 1.655-1.345 2.995-3 3h-22.29c-0.136 0-0.269 0.041-0.383 0.116l-8.077 5.364c-0.493 0.319-1.063 0.501-1.65 0.525h-14.1c-1.6548-4e-3 -2.9951-1.345-3-3v-37.495c2e-3 -0.809 0.6446-1.47 1.4527-1.496zm54.267 24.738c0.846-0.15 1.41-0.958 1.259-1.804-0.023-0.13-0.062-0.257-0.118-0.377l-0.01-0.019-8e-3 -0.019-9.795-21.034-7e-3 -5e-3h-43.966c-4e-3 0-7e-3 4e-3 -7e-3 8e-3v3e-3l9.254 22.491c0.217 0.456 0.673 0.749 1.178 0.756zm-54.22 14.253c0 0.829 0.6715 1.5 1.5 1.5h14.1c0.309-0.025 0.607-0.13 0.865-0.303l8.032-5.332c0.36-0.239 0.782-0.366 1.213-0.366h22.29c0.828 0 1.5-0.672 1.5-1.5v-6.744h-36.75c-0.04 0-0.075-7e-3 -0.117-8e-3h-0.633c-1.099-6e-3 -2.095-0.65-2.55-1.65l-9.4358-22.931c-0.0012-4e-3 -0.0055-6e-3 -0.0094-5e-3 -0.0023 1e-3 -0.0041 3e-3 -0.0048 5e-3z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18796)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.8125 -1.88e-7 -7.54e-7 .82292 530.25 150.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18806)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.634 28.866h-50.25v3.766h48v6.348l4.5 0.386-0.3 3.502c-0.329 3.879-3.571 6.861-7.463 6.866-0.24 0-0.483-0.011-0.726-0.035l-50.298-4.823c-1.5389-0.147-2.7136-1.44-2.7135-2.986v-13.129c-1.3159-0.349-2.2367-1.534-2.25-2.895v-3h64.5v3c0 1.657-1.343 3-3 3zm-9.75 9.472v-4.206h-40.5v0.73zm6-4.206h-4.5v4.334l4.5 0.385zm-54 1.615v6.143c-0.0025 0.774 0.5861 1.422 1.3567 1.493l50.3 4.823c0.193 0.019 0.388 0.028 0.582 0.028 3.107-0.02 5.691-2.398 5.969-5.493l0.171-2.009zm59.25-11.381h-61.5v1.5c0.0165 0.682 0.4805 1.271 1.1392 1.447l1.1108 0.3v6.629l6 0.496v-7.372h51.75c0.828 0 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.384 40.491c0-0.621-0.504-1.125-1.125-1.125s-1.125 0.504-1.125 1.125 0.504 1.125 1.125 1.125 1.125-0.504 1.125-1.125z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18840)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3646,-1.88e-7,-7.54e-7,1.3646,586.5,160.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18850)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.659 46.125h-11.275v-1.5h10.275l7.478-18.051h-17.786l-8e-3 -0.561c-4e-3 -2.945-2.112-5.466-5.01-5.99-3.263-0.519-6.329 1.704-6.849 4.967-0.045 0.279-0.069 0.561-0.074 0.844l-9e-3 0.74h-17.786l7.477 18.051h10.292v1.5h-11.294l-8.223-19.852v-16.881h51.017v16.881zm-41.292-35.233v14.182h16.592c0.461-4.097 4.156-7.044 8.253-6.583 3.461 0.39 6.193 3.122 6.583 6.583h16.589v-14.182z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.909 39.896-1.061-1.06 9.527-9.531 9.534 9.531-1.061 1.06-7.71-7.707c-3e-3 -3e-3 -8e-3 -3e-3 -0.011 0-1e-3 2e-3 -2e-3 4e-3 -2e-3 5e-3v29.672h-1.5v-29.672c0-9e-3 -5e-3 -0.012-0.013-5e-3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18906)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.2591 .31524 -.30661 .252 299.5 156.28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.059 6.366h0.15c6.997 0.0079 12.667 5.678 12.675 12.675v15.825h-1.5v-15.825c-7e-3 -6.169-5.006-11.168-11.175-11.175h-0.15c-6.169 7e-3 -11.168 5.006-11.175 11.175v38.4c5e-3 4.099 3.326 7.42 7.425 7.425h0.15c4.099-5e-3 7.42-3.326 7.425-7.425v-35.4c-2e-3 -2.029-1.646-3.673-3.675-3.675h-0.15c-2.029 2e-3 -3.673 1.646-3.675 3.675v18.075h-1.5v-18.075c3e-3 -2.857 2.318-5.172 5.175-5.175h0.15c2.857 3e-3 5.172 2.318 5.175 5.175v35.4c-5e-3 4.927-3.998 8.92-8.925 8.925h-0.15c-4.927-5e-3 -8.92-3.998-8.925-8.925v-38.4c8e-3 -6.997 5.678-12.667 12.675-12.675z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18970)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9588 .28406 -.28406 .95881 340.83 239.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.884 66.366v-60h45v43.81l-16.19 16.19zm29.263-2.573 13.164-13.164c3e-3 -3e-3 3e-3 -8e-3 0-0.011-2e-3 -1e-3 -4e-3 -2e-3 -6e-3 -2e-3h-13.171v13.171c0 5e-3 3e-3 8e-3 8e-3 8e-3 2e-3 0 3e-3 -1e-3 5e-3 -2e-3zm-27.763-55.927v57h26.25v-15.75h15.75v-41.25z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19012)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6979,0,-1.88e-7,1.6875,156.75,61.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19022)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.8915 46.866h2.2495v-32.993h52.493v32.993h2.25v12h-56.992zm53.242-31.493h-49.493v31.493h49.493zm-51.742 41.993h53.992v-9h-53.992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.634 33.366v7.5h-16.5v-7.5zm-15 6h13.5v-4.5h-13.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19034)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6771,-1.88e-7,-1.88e-7,1.6771,155.25,141)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19044)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.134 16.116v42.75h-15.75v-10.5h-12v9h-12.75v4.5h-9v-45.75h-0.75v-5.25h51v5.25zm-14.25 41.25h12.75v-5.25h-12.75zm0-9v2.25h12.75v-25.5h-12.75zm12.75-24.75v-7.5h-12.75v7.5zm-14.25 23.25v-30.75h-12v30.75zm-13.5 9v-39.75h-11.25v39.75zm-18.75 4.5h6v-44.25h-6zm47.25-48h-48v2.25h48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.884 52.866h-5.25v-5.25h5.25zm-1.5-3.75h-2.25v2.25h2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.884 40.866c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.884 23.616c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5 0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19060)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.92708 -1.88e-7 -3.77e-7 .92708 436.5 192.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.634 15.35h49.5c1.655 6e-3 2.995 1.346 3 3v30.009c-5e-3 1.655-1.345 2.995-3 3h-25.5l-8.25 5.475c-0.472 0.362-1.056 0.548-1.65 0.525h-14.1c-1.6548-5e-3 -2.9951-1.345-3-3v-36.008c0.0045-1.655 1.3449-2.996 3-3.001zm-1.5 39.011c0 0.828 0.672 1.5 1.5 1.5h14.1c0.243 0.017 0.485-0.045 0.689-0.177l0.063-0.053 0.068-0.045 8.25-5.475 0.375-0.25h25.955c0.828 0 1.5-0.672 1.5-1.5v-30.01c0-0.828-0.672-1.5-1.5-1.5h-49.5c-0.828 0-1.5 0.672-1.5 1.5z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19080)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.91667 -1.88e-7 -7.54e-7 .92708 492.75 189.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.634 15.35h49.5c1.655 6e-3 2.995 1.346 3 3v30.009c-5e-3 1.655-1.345 2.995-3 3h-25.5l-8.25 5.475c-0.472 0.362-1.056 0.548-1.65 0.525h-14.1c-1.6548-5e-3 -2.9951-1.345-3-3v-36.008c0.0045-1.655 1.3449-2.996 3-3.001zm-1.5 39.011c0 0.828 0.672 1.5 1.5 1.5h14.1c0.243 0.017 0.485-0.045 0.689-0.177l0.063-0.053 0.068-0.045 8.25-5.475 0.375-0.25h25.955c0.828 0 1.5-0.672 1.5-1.5v-30.01c0-0.828-0.672-1.5-1.5-1.5h-49.5c-0.828 0-1.5 0.672-1.5 1.5z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m283.88 138.76v24.36",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 5.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.88 138.76v24.36",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 5.25
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.40625 -1.88e-7 -3.77e-7 .39583 300 171)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.059 6.366h0.15c6.997 0.0079 12.667 5.678 12.675 12.675v15.825h-1.5v-15.825c-7e-3 -6.169-5.006-11.168-11.175-11.175h-0.15c-6.169 7e-3 -11.168 5.006-11.175 11.175v38.4c5e-3 4.099 3.326 7.42 7.425 7.425h0.15c4.099-5e-3 7.42-3.326 7.425-7.425v-35.4c-2e-3 -2.029-1.646-3.673-3.675-3.675h-0.15c-2.029 2e-3 -3.673 1.646-3.675 3.675v18.075h-1.5v-18.075c3e-3 -2.857 2.318-5.172 5.175-5.175h0.15c2.857 3e-3 5.172 2.318 5.175 5.175v35.4c-5e-3 4.927-3.998 8.92-8.925 8.925h-0.15c-4.927-5e-3 -8.92-3.998-8.925-8.925v-38.4c8e-3 -6.997 5.678-12.667 12.675-12.675z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19124)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.3956 -.10004 .097304 .38477 281.4 185.65)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.059 6.366h0.15c6.997 0.0079 12.667 5.678 12.675 12.675v15.825h-1.5v-15.825c-7e-3 -6.169-5.006-11.168-11.175-11.175h-0.15c-6.169 7e-3 -11.168 5.006-11.175 11.175v38.4c5e-3 4.099 3.326 7.42 7.425 7.425h0.15c4.099-5e-3 7.42-3.326 7.425-7.425v-35.4c-2e-3 -2.029-1.646-3.673-3.675-3.675h-0.15c-2.029 2e-3 -3.673 1.646-3.675 3.675v18.075h-1.5v-18.075c3e-3 -2.857 2.318-5.172 5.175-5.175h0.15c2.857 3e-3 5.172 2.318 5.175 5.175v35.4c-5e-3 4.927-3.998 8.92-8.925 8.925h-0.15c-4.927-5e-3 -8.92-3.998-8.925-8.925v-38.4c8e-3 -6.997 5.678-12.667 12.675-12.675z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19144)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.92708 -1.88e-7 -3.77e-7 .91667 392.25 153.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath19154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.634 15.35h49.5c1.655 6e-3 2.995 1.346 3 3v30.009c-5e-3 1.655-1.345 2.995-3 3h-25.5l-8.25 5.475c-0.472 0.362-1.056 0.548-1.65 0.525h-14.1c-1.6548-5e-3 -2.9951-1.345-3-3v-36.008c0.0045-1.655 1.3449-2.996 3-3.001zm-1.5 39.011c0 0.828 0.672 1.5 1.5 1.5h14.1c0.243 0.017 0.485-0.045 0.689-0.177l0.063-0.053 0.068-0.045 8.25-5.475 0.375-0.25h25.955c0.828 0 1.5-0.672 1.5-1.5v-30.01c0-0.828-0.672-1.5-1.5-1.5h-49.5c-0.828 0-1.5 0.672-1.5 1.5z",
    fill: "#000000"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/30.497bf10c6796139866851541baf02a6b.svg";
export { ForwardRef as ReactComponent };